import React, { useEffect, useState } from 'react';
import API from '../../../Utils/api';
import { useUser } from '../../../Context/useUser';
import { useParams } from 'react-router';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import UpdateWorkout from '../../AthletePage/CalendarPage/UpdateWorkout';
import { toast } from 'react-toastify';

const statusColors = {
    Completed: '#34D399',
    Assigned: '#60A5FA',
    Declined: '#F87171'
};

export default function WorkoutList() {
    const { user } = useUser();
    const { athleteId } = useParams();
    const visitedUser = useVisitingUser(athleteId);
    const currentUser = athleteId ? visitedUser : user;
    const [workouts, setWorkouts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedWorkout, setSelectedWorkout] = useState(null);

    useEffect(() => {
        if (!currentUser) return;
        setLoading(true);
        API.getUpcomingWorkouts(currentUser._id)
            .then(({ data }) => setWorkouts(data))
            .finally(() => setLoading(false));
    }, [currentUser]);

    const handleWorkoutClick = async workoutId => {
        try {
            const { data } = await API.getWorkoutById(workoutId);
            setSelectedWorkout(data);
        } catch (err) {
            toast.error('Failed to load workout data');
        }
    };

    const handleCloseModal = () => setSelectedWorkout(null);
    const handleWorkoutSuccess = (message, data) => {
        toast.success(message);
        setSelectedWorkout(null);
        // Refresh workouts
        API.getUpcomingWorkouts(currentUser._id)
            .then(({ data }) => setWorkouts(data))
            .catch(() => {});
    };
    const handleWorkoutFailure = message => {
        toast.error(message);
    };

    return (
        <>
            <h4 style={{ marginBottom: 10 }}>Upcoming Events</h4>
            {loading ? (
                <div>Loading...</div>
            ) : workouts.length === 0 ? (
                <div>No upcoming events found.</div>
            ) : (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {workouts.map(w => (
                        <li
                            key={w._id}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '8px 0',
                                borderBottom: '1px solid #eee',
                                cursor: 'pointer',
                                transition: 'background 0.2s'
                            }}
                            onClick={() => handleWorkoutClick(w._id)}
                            title='Click to update workout'
                        >
                            <span>
                                {new Date(w.workoutStart).toLocaleDateString()}
                                {w.programGroup?.programSnapshot?.program?.name && (
                                    <span style={{ color: '#666', fontSize: 12 }}>
                                        ({w.programGroup.programSnapshot.program.name})
                                    </span>
                                )}
                            </span>
                            <span
                                style={{ color: statusColors[w.status] || '#666', fontWeight: 600 }}
                            >
                                {w.status}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
            {selectedWorkout && (
                <UpdateWorkout
                    data={selectedWorkout}
                    closeCB={handleCloseModal}
                    onSuccess={handleWorkoutSuccess}
                    onFailure={handleWorkoutFailure}
                    athleteCSS={selectedWorkout.css ?? currentUser?.currentCSS}
                    athleteMSS={selectedWorkout.mss ?? currentUser?.currentMSS}
                />
            )}
        </>
    );
}
